<template>
  <result-card
    image="/img/payment-succeeded.png"
    title="Баланс пополнен"
    text="Средства зачислены на баланс. Чек отправлен на e-mail."
    action-label="Вернуться к заказам"
    @action="$emit('action')"
  >
    <p class="payment-succeeded__amount">
      +{{ formattedAmount }}
    </p>
  </result-card>
</template>

<script>
  import ResultCard from './ResultCard'

  export default {
    name: 'PaymentSucceeded',
    components: { ResultCard },
    props: {
      amount: {
        type: Number,
        default: 0,
      },
    },
    computed: {
      formattedAmount () {
        return `${(this.amount || 0).toLocaleString('ru-RU')} ₽`
      },
    },
  }
</script>

<style lang="less" scoped>
.payment-succeeded__amount {
  margin-bottom: 16px;
  font-size: 22px;
  font-weight: 500;
  color: @color-success;
}
</style>
